import { useState, useCallback } from 'react';
import { checkViewerSupport } from '../api/viewerSupportService';
import { useAuth } from '../contexts/AuthContext';

/**
 * Simple hook for checking viewer support for files
 */
export const useViewerSupport = () => {
    const [loading, setLoading] = useState(false);
    const { getAccessToken } = useAuth();

    /**
     * Check if a file name is supported by the viewer
     * @param {string} fileName - The file name to check
     * @returns {Promise<boolean>} - True if supported
     */
    const checkSupport = useCallback(async (fileName) => {
        console.log('useViewerSupport.checkSupport called with:', fileName);
        
        if (!fileName) {
            console.log('No file name provided');
            return false;
        }

        try {
            setLoading(true);
            const accessToken = await getAccessToken();
            
            if (!accessToken) {
                console.log('No access token available');
                return false;
            }

            const isSupported = await checkViewerSupport(fileName, accessToken);
            console.log(`File "${fileName}" supported:`, isSupported);
            
            return isSupported;
        } catch (error) {
            console.error('Error checking viewer support:', error);
            return false;
        } finally {
            setLoading(false);
        }
    }, [getAccessToken]);

    return {
        checkSupport,
        loading
    };
};